'use client';

import { c as _c } from "react/compiler-runtime";
import FacebookLogin from '@greatsumini/react-facebook-login';
import _ from 'lodash';
import { redirect } from 'next/navigation';
import { useEffect, useState } from 'react';
import { authApi } from '@/api';
import { Button } from '@/components';
import { facebookAppId, pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
import type { Auth } from '@/types/auth';

// https://medium.com/@syedmahmad/login-with-facebook-meta-in-react-app-88efb7a9fc0a

export function SignInWithFacebook(t0) {
  const $ = _c(17);
  const {
    afterSignInAction
  } = t0;
  const {
    user,
    setUser
  } = useGlobalStore(_temp);
  const [isWorking, setIsWorking] = useState(false);
  const [token, setToken] = useState(null);
  let t1;
  if ($[0] !== setUser || $[1] !== token) {
    t1 = async function signIn() {
      setIsWorking(true);
      try {
        const d = await authApi.signInWithFacebook({
          token
        });
        setUser(d.data, null);
      } catch {
        setIsWorking(false);
      }
    };
    $[0] = setUser;
    $[1] = token;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const signIn = t1;
  let t2;
  if ($[3] !== afterSignInAction || $[4] !== isWorking || $[5] !== user) {
    t2 = () => {
      if (_.isEmpty(user) || !isWorking) {
        return;
      }
      setIsWorking(false);
      if (afterSignInAction) {
        afterSignInAction();
      } else {
        redirect(pages.myProfile.href);
      }
    };
    $[3] = afterSignInAction;
    $[4] = isWorking;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = user?._id;
  let t4;
  if ($[7] !== t3) {
    t4 = [t3];
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t2, t4);
  let t5;
  if ($[9] !== signIn || $[10] !== token) {
    t5 = () => {
      if (!token) {
        return;
      }
      setIsWorking(true);
      signIn();
    };
    $[9] = signIn;
    $[10] = token;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== token) {
    t6 = [token];
    $[12] = token;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = res => {
      setToken(res.accessToken);
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isWorking) {
    t8 = <FacebookLogin appId={facebookAppId} onSuccess={t7} render={t9 => {
      const {
        onClick
      } = t9;
      return <Button type="button" variant="outline" className="btn-signin" onClick={onClick} working={isWorking} aria-label="Sign in with Facebook" aria-busy={isWorking}><img src="/img/facebook-logo-128.png" className="mr-3 w-5" alt="" aria-hidden="true" />Sign in with Facebook</Button>;
    }} />;
    $[15] = isWorking;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(state) {
  return state;
}